import { render, staticRenderFns } from "./ViewerSettings.vue?vue&type=template&id=db0f8d64&scoped=true&"
import script from "./ViewerSettings.vue?vue&type=script&lang=ts&"
export * from "./ViewerSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ViewerSettings.vue?vue&type=style&index=0&id=db0f8d64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0f8d64",
  null
  
)

export default component.exports